import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    codigoPromocion: '',
    cuit: '',

    id: 0,
    razonSocial: '',
    cuit: '',
    negocioPais: '',
    negocioProvincia: '',
    negocioLocalidad: '',
    negocioBarrio: '',
    negocioDireccion: '',
    negocioCodigoPostal: '',
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, eventoId) {
        state.eventoId = eventoId;
        state.codigoPromocion = '';
        state.cuit = '';
    },
    'INICIALIZAR_PARTICIPANTE' (state) {
        state.id = 0;

        state.razonSocial = '';
        state.negocioPais = '';
        state.negocioProvincia = '';
        state.negocioLocalidad = '';
        state.negocioBarrio = '';
        state.negocioDireccion = '';
        state.negocioCodigoPostal = '';
    },
    'SET_PARTICIPANTE' (state, participante) {
        state.id = participante.id;

        state.razonSocial = participante.negocio? participante.negocio.razonSocial : '';
        state.negocioPais = participante.negocio? participante.negocio.pais : '';
        state.negocioProvincia = participante.negocio? participante.negocio.provincia : '';
        state.negocioLocalidad = participante.negocio? participante.negocio.localidad : '';
        state.negocioBarrio = participante.negocio? participante.negocio.barrio : '';
        state.negocioDireccion = participante.negocio? participante.negocio.direccion : '';
        state.negocioCodigoPostal = participante.negocio? participante.negocio.codigoPostal : '';
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, eventoId ) {
        commit('INICIALIZAR', eventoId);
    },
    getParticipanteReinscripcion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARTICIPANTE');

            /* Recuperamos los datos del participante a partir de los parametros */
            let query = '?codigoPromocion=' + state.codigoPromocion
                + '&cuitNegocio=' + state.cuit;

            apiAxios.get('eventos/' + state.eventoId + '/participante' + query)
                .then(res => {
                    commit('SET_PARTICIPANTE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('eventos/' + state.eventoId + '/participante/' + state.id + '/reinscripcion')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}